module.exports = __webpack_public_path__ + "img/pauli-z.3ae62f88.svg";